module.exports = __webpack_public_path__ + "images/pages/kaitori_bonus_cp_lp/may/mainvisual-bg-sp_b6a880d8577adac65164210314d33c40.png";